"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (hoc) {
  return hoc(function (props) {
    return props.children(props);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/utils/toRenderProps.js
// module id = 1641
// module chunks = 2